export const SECTION4_PORTAL_ASSESSMENT_VALUES = {
    'Documentation 1': ['compliant', 'not_cited', 'medium_non_compliance'],
    'SB & Labelling 13': ['compliant', 'medium_non_compliance', 'rectification_work'],
    'SB & Labelling 14': ['compliant', 'rectification_work'],
    'SB & Labelling 15': ['compliant', 'unsafe'],
    'SB & Labelling 21': ['compliant', 'medium_non_compliance'],
    'SB & Labelling 22': ['compliant', 'rectification_work'],
    'Integrated BESS 20': ['compliant', 'medium_non_compliance', 'rectification_work'],
    'Integrated BESS 21': ['compliant', 'medium_non_compliance'],
    'Integrated BESS 22': ['compliant', 'unsafe'],
    'Integrated BESS 37': ['compliant', 'medium_non_compliance'],
    'Integrated BESS 38': ['compliant', 'rectification_work'],
    'Integrated BESS 46': ['compliant', 'unsafe'],
    'Integrated BESS 47': ['compliant', 'rectification_work'],
    'Integrated BESS 48': [
        'compliant',
        'not_applicable',
        'medium_non_compliance',
        'rectification_work',
        'unsafe',
    ],
    'Integrated BESS 49': ['compliant', 'not_applicable', 'medium_non_compliance'],
    'Integrated BESS 50': ['compliant', 'not_applicable', 'unsafe'],
    'Integrated BESS 51': ['compliant', 'rectification_work', 'unsafe'],
    'Integrated BESS 52': ['compliant', 'unsafe'],
    'Integrated BESS 4': ['compliant', 'rectification_work', 'unsafe'],
    'Integrated BESS 5': ['compliant', 'unsafe'],
    'Integrated BESS 11': ['compliant', 'rectification_work'],
    'Integrated BESS 12': ['not_applicable', 'unsafe_product_recall'],
    'Integrated BESS 18': ['compliant', 'medium_non_compliance'],
    'Integrated BESS 24': ['compliant', 'not_applicable', 'medium_non_compliance'],
    'Integrated BESS 25': ['compliant', 'medium_non_compliance'],
    'Integrated BESS 39': ['compliant', 'not_applicable', 'rectification_work'],
    'Integrated BESS 43': ['compliant', 'not_applicable', 'medium_non_compliance'],
    'Integrated BESS 44': ['compliant', 'not_applicable', 'medium_non_compliance'],
    'Integrated BESS 45': ['compliant', 'medium_non_compliance'],
    'SB & Labelling 11': ['compliant', 'medium_non_compliance', 'rectification_work'],
    'SB & Labelling 23': ['compliant', 'medium_non_compliance'],
    'SB & Labelling 24': ['compliant', 'medium_non_compliance'],
    'SB & Labelling 27': ['compliant', 'not_applicable', 'medium_non_compliance'],
    'SB & Labelling 33': ['compliant', 'unsafe'],
    'Integrated BESS 19': [
        'compliant',
        'not_applicable',
        'medium_non_compliance',
        'rectification_work',
    ],
    'SB & Labelling 1': ['compliant', 'medium_non_compliance'],
    'SB & Labelling 2': ['compliant', 'medium_non_compliance'],
    'SB & Labelling 3': ['compliant', 'not_applicable', 'medium_non_compliance'],
    'SB & Labelling 4': ['compliant', 'not_applicable', 'medium_non_compliance'],
    'SB & Labelling 5': [
        'compliant',
        'not_applicable',
        'minor_non_compliance',
        'medium_non_compliance',
    ],
    'SB & Labelling 6': ['compliant', 'medium_non_compliance'],
    'SB & Labelling 8': ['compliant', 'medium_non_compliance'],
    'SB & Labelling 16': ['compliant', 'rectification_work'],
    'SB & Labelling 17': ['compliant', 'medium_non_compliance'],
    'SB & Labelling 18': ['compliant', 'not_applicable', 'medium_non_compliance'],
    'SB & Labelling 19': ['compliant', 'medium_non_compliance', 'rectification_work'],
    'SB & Labelling 25': ['compliant', 'medium_non_compliance'],
    'SB & Labelling 28': ['compliant', 'medium_non_compliance'],
    'Integrated BESS 13': ['compliant', 'not_applicable', 'medium_non_compliance'],
    'Integrated BESS 14': ['compliant', 'medium_non_compliance'],
    'Integrated BESS 15': ['compliant', 'medium_non_compliance'],
    'Integrated BESS 16': ['compliant', 'medium_non_compliance'],
    'Integrated BESS 17': ['compliant', 'not_applicable', 'medium_non_compliance'],
    'Integrated BESS 23': ['compliant', 'rectification_work'],
    'Integrated BESS 41': ['compliant', 'not_applicable', 'rectification_work'],
    'Integrated BESS 42': ['compliant', 'not_applicable', 'rectification_work'],
    'SB & Labelling 10': ['compliant', 'rectification_work'],
    'SB & Labelling 20': ['compliant', 'medium_non_compliance'],
    'SB & Labelling 29': ['compliant', 'rectification_work'],
    'SB & Labelling 30': ['compliant', 'rectification_work'],
    'SB & Labelling 31': ['compliant', 'rectification_work'],
    'SB & Labelling 26': ['compliant', 'medium_non_compliance'],
    'Integrated BESS 35': [
        'compliant',
        'not_applicable',
        'medium_non_compliance',
        'rectification_work',
    ],
    'Integrated BESS 36': ['compliant', 'medium_non_compliance'],
    'Integrated BESS 26': [
        'compliant',
        'not_applicable',
        'medium_non_compliance',
        'rectification_work',
    ],
    'Integrated BESS 27': ['compliant', 'rectification_work'],
    'Integrated BESS 28': ['compliant', 'rectification_work'],
    'Integrated BESS 29': ['compliant', 'medium_non_compliance'],
    'Integrated BESS 30': ['compliant', 'not_applicable', 'rectification_work'],
    'Integrated BESS 31': ['compliant', 'rectification_work'],
    'Integrated BESS 32': ['compliant', 'medium_non_compliance'],
    'Integrated BESS 33': ['compliant', 'medium_non_compliance'],
    'Integrated BESS 34': ['compliant', 'medium_non_compliance'],
};
//# sourceMappingURL=section4-portal-options.js.map